import { useEffect, useState } from "react";
export const useIsMinViewportSize = ({ minViewportHeight = 0, minViewportWidth = 0 }) => {
    const [isMinViewportSize, setIsMinViewportSize] = useState(true);
    useEffect(() => {
        // if min viewport size requirement, update state on browser resize
        if (minViewportHeight || minViewportWidth) {
            const updateIsMinViewportSize = () => setIsMinViewportSize(window.innerHeight >= minViewportHeight && window.innerWidth >= minViewportWidth);
            updateIsMinViewportSize();
            window.addEventListener("resize", updateIsMinViewportSize);
            return () => {
                window.removeEventListener("resize", updateIsMinViewportSize);
            };
        }
        return undefined;
    }, [minViewportHeight, minViewportWidth]);
    return isMinViewportSize;
};
